import { GET_BOOKMARKS_SUCCES } from 'modules/usefulLinks/actions';

const initialState = {
  usefulLinks: [],
};

export const bookmarksReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BOOKMARKS_SUCCES: {
      const { links } = action.payload;
      return {
        ...state,
        usefulLinks: links,
      };
    }
    default:
      return state;
  }
};
